import { render } from "./SelectCategoryItem.vue?vue&type=template&id=767d0fa4&scoped=true&ts=true"
import script from "./SelectCategoryItem.vue?vue&type=script&lang=ts"
export * from "./SelectCategoryItem.vue?vue&type=script&lang=ts"

import "./SelectCategoryItem.vue?vue&type=style&index=0&id=767d0fa4&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-767d0fa4"]])

export default __exports__